module.exports = __webpack_public_path__ + "img/red-2.7f62ab16.svg";